export const copyTextToClipboard = async (content = '') => {
  if (content.length === 0) return false;
  await navigator.clipboard.writeText(content);
  return true;
};
